export const queryClientConfig = {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    }
};